<template>
  <el-dialog
    title="开始上传"
    :close-on-click-modal="false"
    :show-close="false"
    :visible.sync="visible"
    width="800px">
    <el-upload
      class="import-excel"
      ref="upload"
      accept=".xls,.xlsx"
      :headers="myHeader"
      :action="uploadUrl"
      :show-file-list="false"
      :auto-upload="false"
      :multiple="false"
      :on-success="handleSuccess"
      :before-upload="beforeExcelUpload"
      :on-error="handleError"
      :file-list="fileList"
      :on-change="changeFile">
      <el-input v-model="fileName" :disabled="true" class="import-excel-input" style="width: 560px"></el-input>
      <el-button slot="trigger" type="primary" icon="el-icon-upload2" :loading="loading">选取文件</el-button>
    </el-upload>
    <div class="line"></div>
    <el-row>
      <el-col :span="7">
        <el-button @click="closeDialogImport" :loading="loading">取消</el-button>
        <el-button type="primary" @click="submitUpload" :loading="loading">上传</el-button>
      </el-col>
    </el-row>

    <el-dialog
      title="数据上传失败，错误信息如下"
      :close-on-click-modal="false"
      :visible.sync="hasError"
      append-to-body
      width="800px"
      heiht="600px">
      <el-button type="primary" class="export"
                  @click="exportBtn">{{ $t('export') }}</el-button>
      <el-button class="shutDown" @click="shutDownBtn" :loading="loading">关闭</el-button>
      <el-table
        :data="errorList"
        border
        height="500"
        style="width: 100%;">
        <el-table-column
          type="index"
          :index="indexMethod" label="编号"
          header-align="center"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="fieldKey"
          header-align="center"
          align="center"
          show-overflow-tooltip
          label="字段名">
        </el-table-column>
        <el-table-column
          prop="fieldValue"
          header-align="center"
          align="center"
          show-overflow-tooltip
          label="字段值">
        </el-table-column>
        <el-table-column
          prop="errorReason"
          header-align="center"
          align="center"
          show-overflow-tooltip
          label="错误原因">
        </el-table-column>
        <el-table-column
          prop="rowNumber"
          header-align="center"
          align="center"
          show-overflow-tooltip
          label="错误行">
        </el-table-column>
      </el-table>
    </el-dialog>
  </el-dialog>

</template>

<script>
export default {
  name: 'certImport',
  data () {
    return {
      loading: false,
      myHeader: { token: '' }, // token
      fileList: [],
      errorList: [],
      fileName: '',
      uploadUrl: '',
      hasError: false
    }
  },
  props: {
    visible: {// 是否显示
      type: Boolean,
      required: false,
      default: false
    },
    curYear: {// 当前年度
      type: String,
      required: true
    },
    url: {// 文件提交位置
      type: String,
      required: true
    },
    isShowNote: {// 是否显示导入备注
      type: Boolean,
      required: false,
      default: false
    }
  },
  created () {
    if (this.curYear.indexOf("-") >= 0) {
      this.uploadUrl = window.SITE_CONFIG['apiBaseURL'] + this.url + `?token=${this.getStorage(this.GLOBAL.TOKEN)}&curYearMonth=${this.curYear}`
    } else {
      this.uploadUrl = window.SITE_CONFIG['apiBaseURL'] + this.url + `?token=${this.getStorage(this.GLOBAL.TOKEN)}&curYear=${this.curYear}`
    }
    this.myHeader.token = this.getStorage(this.GLOBAL.TOKEN)
    this.num = 0
    this.fileList = []
    this.visible = false
  },
  methods: {
    indexMethod (index) {
      return index + 1
    },
    beforeExcelUpload (file) {
      console.log(file)
      let maxLength = 10 * 1024 * 1024
      if (file.size > maxLength) {
        this.$message({
          message: '大小不能超过10M',
          type: 'error',
          duration: 1500,
          onClose: () => {
            this.init()
            this.$emit('getDataList')
          }
        })
        return false
      }
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      let uploadFormat = ['xlsx', 'xls', 'XLSX', 'XLS']
      let falg = uploadFormat.indexOf(testmsg)
      // 校验文件格式
      if (falg === -1) {
        this.$message({
          message: '只能上传Excel',
          type: 'error',
          duration: 1500,
          onClose: () => {
            this.init()
            this.$emit('getDataList')
          }
        })
        return false
      }
      return true
    },
    init:function () {
      this.visible = true
      this.fileName = ''
      this.fileList = []
      this.loading = false
      if (this.curYear.indexOf("-") >= 0) {
        this.uploadUrl = window.SITE_CONFIG['apiBaseURL'] + this.url + `?curYearMonth=${this.curYear}`
      } else {
        this.uploadUrl = window.SITE_CONFIG['apiBaseURL'] + this.url + `?curYear=${this.curYear}`
      }
    },
    submitUpload () {
      if (this.curYear.indexOf("-") >= 0) {
        this.uploadUrl = window.SITE_CONFIG['apiBaseURL'] + this.url + `?curYearMonth=${this.curYear}`
      } else {
        this.uploadUrl = window.SITE_CONFIG['apiBaseURL'] + this.url + `?curYear=${this.curYear}`
      }
      if (this.fileName) {
        this.loading = true
        this.$refs.upload.submit()
      }
    },
    changeFile (file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        this.fileName = file.name
        this.fileList = fileList
      }
    },
    handleSuccess (response, file, fileList) {
      console.log(response)
      console.log(file)
      console.log(fileList)
      if (response.data !== null && response.data.length > 0) {
        this.errorList = response.data
        this.hasError = true
        this.init()
        this.$emit('getDataList')
        return
      }
      if (Number(fileList[0].response.code) < 0) {
        this.$message({
          message: fileList[0].response.msg,
          type: 'error',
          duration: 1500,
          onClose: () => {
            this.init()
            this.$emit('getDataList')
          }
        })
        return 0
      }
      this.$message({
        message: '导入成功',
        type: 'success',
        duration: 1500
      })
      this.init()
      this.$emit('closeDialogImport')
    },
    handleError (err, file, fileList) {
      console.log(err + file + fileList)
      this.loading = false
      this.fileName = ''
      this.fileList = []
      this.$message.error('导入失败！')
    },
    // 关闭导入弹框,每次关闭时清空文件名
    closeDialogImport () {
      this.fileList = []
      this.fileName = ''
      this.$emit('closeDialogImport')
    },
    //导出
    exportBtn() {
      this.$request.downloadByPost('/learning/achieveKeyCertSetting/exportErrorInfo', this.$t('cert.downloadExcelError'),
        this.errorList
      ).then((data) => {
        let downloadFileName = 'download.xls' && this.$t('cert.downloadExcelError') + '.xls'
        let reader = new FileReader()
        reader.readAsDataURL(data) // 转换为base64，可以直接放入a表情href
        reader.onload = function (e) {
          var parts = e.target.result.split(';base64,')
          var contentType = parts[0].split(':')[1]
          var raw = window.atob(parts[1])
          var rawLength = raw.length
          var uInt8Array = new Uint8Array(rawLength)
          for (var i = 0; i < rawLength; i++) {
            uInt8Array[i] = raw.charCodeAt(i)
          }
          var blob = new Blob([uInt8Array], { type: contentType })
          if (navigator.userAgent.indexOf('Trident') > -1 || navigator.userAgent.indexOf('Edge') > -1) {
            window.navigator.msSaveBlob(blob, downloadFileName)
          } else {
            // 转换完成，创建一个a标签用于下载
            var a = document.createElement('a')
            a.download = downloadFileName
            a.href = e.target.result
            document.getElementsByTagName('body')[0].appendChild(a) // 修复firefox中无法触发click
            a.click()
            document.getElementsByTagName('body')[0].removeChild(a)
          }
        }
        this.$message({
          message: '导出成功',
          type: 'success',
          duration: 1000
        })
          this.hasError = false;
      })
    },
    //导出关闭
    shutDownBtn() {
      this.hasError = false;
    }
  }
}
</script>
<style>
  .import-excel .el-upload.el-upload--text {
    float: right;
    margin-right: 37px;
  }
  .import-excel {
    height: 60px;
  }
  .import-excel .import-excel-input .el-input__inner{
    color: black;
  }
</style>
<style scoped>
  .line {
    height: 1px;
    border-top: 1px solid #b2b0b4;
    text-align: center;
    margin: 10px;
  }
  .export {
    position: absolute;
    top: 15px;
    right: 110px;
  }
  .shutDown {
    position: absolute;
    top: 15px;
    right: 20px;
  }
</style>
